import styled from 'styled-components';

const FlexWrapper = styled.div`
  display: flex;
  justify-content: ${props => props.justifyContent || 'center'};
  align-items: ${props => props.alignItems || 'center'};
  flex-direction: ${props => props.vertical
    ? (props.reverse ? 'column-reverse' : 'column')
    : (props.reverse ? 'row-reverse' : 'row')};
  ${props => props.widthPx && `width: ${props.widthPx}px`};
  ${props => props.fluid && 'width: 100%'};
  ${props => props.heightFluid && 'height: 100%'};
  ${props => props.maxWidth && `max-width: ${props.maxWidth}`};
  ${props => props.relative && 'position: relative'};
  ${props => props.textAlign && `text-align: ${props.textAlign}`};
  ${props => props.flexWrap && 'flex-wrap: wrap'};
  ${props => props.flex && `flex: ${props.flex}`};
  ${props => props.borderBottom && `border-bottom: ${props.borderBottom}`};
`;

export default FlexWrapper;
